var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallenge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-ebdf4158": "",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon small",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8334 11.38H3.1666C2.52274 11.38 2 11.9027 2 12.5466V26.5C2 28.4297 3.57034 30 5.5 30H26.5C28.4297 30 30 28.4297 30 26.5V12.5466C30 11.9027 29.4773 11.38 28.8334 11.38Z",
    fill: "#64AB88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 5.5H5.5C3.56693 5.5 2 7.06692 2 9V12.5466H30V9C30 7.06692 28.4331 5.5 26.5 5.5Z",
    fill: "#429E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00133 2H7.83473C7.19066 2 6.66792 2.52274 6.66792 3.16659V7.8334C6.66792 8.47726 7.19066 8.99999 7.83473 8.99999H9.00133C9.6454 8.99999 10.1679 8.47726 10.1679 7.8334V3.16659C10.1679 2.52274 9.6454 2 9.00133 2Z",
    fill: "#429E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1687 2H23.0021C22.358 2 21.8355 2.52274 21.8355 3.16659V7.8334C21.8355 8.47726 22.358 8.99999 23.0021 8.99999H24.1687C24.8128 8.99999 25.3355 8.47726 25.3355 7.8334V3.16659C25.3355 2.52274 24.8128 2 24.1687 2Z",
    fill: "#429E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenge);
export default __webpack_public_path__ + "static/media/challenge.c650df9bc4e63e4abdd4d0c1c0f28fdb.svg";
export { ForwardRef as ReactComponent };